import { render, staticRenderFns } from "./SaleSelect.vue?vue&type=template&id=3023554a&scoped=true&"
import script from "./SaleSelect.vue?vue&type=script&lang=js&"
export * from "./SaleSelect.vue?vue&type=script&lang=js&"
import style0 from "./SaleSelect.vue?vue&type=style&index=0&id=3023554a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3023554a",
  null
  
)

export default component.exports